import type { ReactNode } from "react";

type Tone = "default" | "primary" | "success" | "warning" | "muted";

const tones: Record<Tone, string> = {
  default: "border-border text-foreground bg-surface",
  primary: "border-primary/30 text-primary bg-primary/10",
  success: "border-[color-mix(in_oklab,var(--success)_40%,transparent)] text-[color-mix(in_oklab,var(--success)_90%,white_10%)] bg-[color-mix(in_oklab,var(--success)_15%,transparent)]",
  warning: "border-[color-mix(in_oklab,var(--warning)_40%,transparent)] text-[color-mix(in_oklab,var(--warning)_90%,white_10%)] bg-[color-mix(in_oklab,var(--warning)_12%,transparent)]",
  muted: "border-border text-muted-foreground bg-transparent",
};

export function Badge({
  tone = "default",
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[0.7rem] font-medium tracking-wide ${tones[tone]} ${className ?? ""}`}
    >
      {children}
    </span>
  );
}

export function EyebrowLabel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-[0.2em] text-primary ${className ?? ""}`}
    >
      <span className="h-1 w-1 rounded-full bg-primary" />
      {children}
    </div>
  );
}
